import { gql } from 'graphql-tag';
import devNote from '@xingternal/malt-util/dev-note';
const queries = {
    GET_INITIAL_DATA: gql `
    query xingFrameQuery {
      viewer {
        id
        webTrackingData {
          PropHashedUserId
        }
        xingId {
          academicTitle
          birthday
          displayName
          displayFlag
          userFlags {
            displayFlag
          }
          firstName
          gender
          globalId
          id
          lastName
          pageName
          profileImage(size: [SQUARE_128]) {
            url
          }
          profileOccupation {
            occupationOrg
            occupationTitle
          }
          occupations {
            headline
            subline
          }
        }
        features {
          isXingEmployee
          isJobsPoster
          isAdmasterUser
          isBrandPageCollaborator
          isBasic
          isPremium
          isExecutive
          isSales
          hasProJobsMembership
          isCraUser
          isSeatManagerAdmin
          showProbusinessInNavigation
          showUpsellHint
          showJobSeekerBoneyardUpsellHint
          showPremiumBoneyardUpsellHint
          hasCoachProfile
          hasNewSettings
          isBrandManagerEditor
        }
        featureSwitches
        loginState
      }
    }
  `,
};
const initialize = async ({ client, broadcastError }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    try {
        const { loading, error, data } = await client.query({
            query: queries.GET_INITIAL_DATA,
        });
        if (error) {
            broadcastError(error, 'The GET_INITIAL_DATA guery call has returned an error!');
        }
        return {
            data: {
                user: (_b = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.xingId) !== null && _b !== void 0 ? _b : {},
                features: (_d = (_c = data === null || data === void 0 ? void 0 : data.viewer) === null || _c === void 0 ? void 0 : _c.features) !== null && _d !== void 0 ? _d : {},
                featureSwitches: (_f = (_e = data === null || data === void 0 ? void 0 : data.viewer) === null || _e === void 0 ? void 0 : _e.featureSwitches) !== null && _f !== void 0 ? _f : [],
                hashedUserId: (_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.viewer) === null || _g === void 0 ? void 0 : _g.webTrackingData) === null || _h === void 0 ? void 0 : _h.PropHashedUserId) !== null && _j !== void 0 ? _j : '',
            },
            meta: {
                loading: loading || false,
                error,
            },
        };
    }
    catch (error) {
        broadcastError(error, 'The GET_INITIAL_DATA guery call has returned an error!');
        return {
            data: {
                user: {},
                features: {},
                featureSwitches: [],
                hashedUserId: '',
            },
            meta: {
                loading: true,
                error,
            },
        };
    }
};
const getHooks = (useFrameHooks) => {
    const useInitialData = () => {
        const { useFrameContext } = useFrameHooks();
        const { user, features, featureSwitches, hashedUserId, loading } = useFrameContext();
        const xingId = {
            ...user,
            ...(user && {
                // If user.id is available
                ...(user.id && {
                    get unscrambledId() {
                        // if user.id is a number, return it. Otherwise, parse and return the int part of it
                        return typeof user.id === 'string'
                            ? parseInt(user.id.split('.')[0])
                            : user.id;
                    },
                }),
                // If user.occupationOrg or user.occupationTitle is used
                profileOccupation: {
                    get occupationOrg() {
                        devNote.warn('occupationOrg is deprecated. Please use `user.occupations[0].headline`.');
                        return user.occupations && user.occupations.length
                            ? user.occupations[0].headline
                            : '';
                    },
                    get occupationTitle() {
                        devNote.warn('occupationTitle is deprecated. Please use `user.occupations[0].subline`.');
                        return user.occupations && user.occupations.length
                            ? user.occupations[0].subline
                            : '';
                    },
                },
            }),
        };
        return { user: xingId, features, featureSwitches, hashedUserId, loading };
    };
    return { useInitialData };
};
export const initialDataModule = {
    name: 'initialDataModule',
    queries,
    initialize,
    getHooks,
};
//# sourceMappingURL=initial-data.js.map